import { useMemo } from "react";

import { JournalEntrySourceType } from "@common/schemas/domains/accounting/journalEntry";
import { JournalEntryDrawerFormikConfig } from "./JournalEntryDrawer";

export function useIsManualJournalEntry(
    values: JournalEntryDrawerFormikConfig,
) {
    return useMemo(
        () =>
            values.journalEntryId === undefined ||
            values.journalEntry.source?.type ===
                JournalEntrySourceType.ManualJournalEntry,
        [values.journalEntry.source, values.journalEntryId],
    );
}

export function useIsTransactionJournalEntry(
    values: JournalEntryDrawerFormikConfig,
) {
    return useMemo(
        () =>
            values.journalEntry.source?.type ===
            JournalEntrySourceType.Transaction,
        [values.journalEntry.source],
    );
}

interface Change<T> {
    field: keyof T;
    value: string | number | string[] | null;
}

export interface UpdateAndReturnNewLineParams<T> {
    line: T;
    changes: Array<Change<T>>;
    fillEmptyFieldsAutomatically?: boolean;
}
